module.exports = __webpack_public_path__ + "static/pers-e3ce031b4b3035dc03889dabff3d5649.jpg";